<template>
  <div class="card border">
    <div v-if="title" :class="headerClasses" class="card-header p-2">
      <h6 :class="titleStyle" class="m-0" v-if="collapse">
        <button class="btn" @click="collapsed = !collapsed; $emit('collapse', collapsed)">
        <i class="mr-2" :class="[icon, iconStyle]"></i> {{ title }}
        </button>
      </h6>
      <h6 :class="titleStyle" class="m-0" v-else>
        <i v-if="icon && icon.length" class="mr-2" :class="[icon, iconStyle]"></i> {{ title }}
      </h6>
      <slot name="header"></slot>
    </div>
    <div :class="bodyStyle" class="card-body">
      <slot></slot>
    </div>
    <div v-if="this.$slots.footer" :class="footerClasses" class="card-footer border-top">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      title: String,
      headerStyle: {
        type: String,
        default: ''
      },
      icon: String,
      bodyClasses: {
        type: String,
        default: 'p-3'
      },
      footerClasses: {
        type: String,
        default: ''
      },
      collapse: {
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        collapsed: this.collapse,
        collapseIcon: this.collapse,
      }
    },
    computed: {
      headerClasses() {
        return this.headerStyle ? `bg-${this.headerStyle}` : ''
      },
      bodyStyle() {
        return this.collapse && this.collapsed ? 'd-none' : this.bodyClasses
      },
      titleStyle() {
        if (this.headerStyle === 'warning') return 'text-dark'
        else return this.headerStyle ? 'text-white' : 'text-dark'
      },
      iconStyle() {
        if (this.collapse) {
          return this.collapsed ? 'fas fa-caret-right' : 'fas fa-caret-down'
        }
        return this.headerStyle ? 'text-white' : 'text-primary'
      }
    }
  }
</script>

<style scoped>
  .card-header {
    display: flex; 
    justify-content: space-between;
    align-items: center;
  }

  @media (max-width: 576px) {
    .card-header {
      flex-direction: column;
      align-items: flex-start;
    }
  }
</style>
